import { Observable } from "rxjs";
import { IconsService } from "./icons.service";

export function initializeIcon(service:IconsService):()=>Observable<any>{
  return ()=> service.setIcon();
}
